/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SmsLenketype = {
    Bestilling: 'BESTILLING',
    Norgespris: 'NORGESPRIS'
} as const;
export type SmsLenketype = typeof SmsLenketype[keyof typeof SmsLenketype];


export function instanceOfSmsLenketype(value: any): boolean {
    for (const key in SmsLenketype) {
        if (Object.prototype.hasOwnProperty.call(SmsLenketype, key)) {
            if (SmsLenketype[key as keyof typeof SmsLenketype] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SmsLenketypeFromJSON(json: any): SmsLenketype {
    return SmsLenketypeFromJSONTyped(json, false);
}

export function SmsLenketypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsLenketype {
    return json as SmsLenketype;
}

export function SmsLenketypeToJSON(value?: SmsLenketype | null): any {
    return value as any;
}

export function SmsLenketypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SmsLenketype {
    return value as SmsLenketype;
}

